import React, { useCallback, useState, useRef, useEffect } from 'react';
import UserfeedColumn from './userfeed_column';

const CommunityUserfeedList = ({currentUser, companyId, hashedCompanyId, hasDepartments}) => {
  const [activeTab, setActiveTab] = useState('all');

  return (
    <React.Fragment>
      <div className="container col-lg-8 bg-white pt-2 d-none d-md-block">
        <div className="row">
          <UserfeedColumn
            column="all"
            currentUser={currentUser}
            companyId={companyId}
            hashedCompanyId={hashedCompanyId}
            hasDepartments={hasDepartments}
          />
          <UserfeedColumn
            column="circle"
            currentUser={currentUser}
            companyId={companyId}
            hashedCompanyId={hashedCompanyId}
            hasDepartments={hasDepartments}
          />
          {hasDepartments && (
            <UserfeedColumn
              column="department"
              currentUser={currentUser}
              companyId={companyId}
              hashedCompanyId={hashedCompanyId}
              hasDepartments={hasDepartments}
            />
          )}
          <UserfeedColumn
            column="active"
            currentUser={currentUser}
            companyId={companyId}
            hashedCompanyId={hashedCompanyId}
            hasDepartments={hasDepartments}
          />      
        </div>
      </div>

      <div className="nav_top__tabbar d-block d-md-none">
        <div className="row align-items-center m-0" style={{ height:"50px" }}>
          <div className="container col-lg-8 gray">
            <ul className="list-unstyled d-flex scrollable-list mb-0 justify-content-around">
              <li 
                className={`text-center top__tabbar cursor-pointer px-2 ${activeTab === 'all' ? 'community_active' : ''}`}
                onClick={() => setActiveTab('all')}
                >
                <p>すべて</p>
              </li>
              <li
                className={`text-center top__tabbar cursor-pointer px-2 ${activeTab === 'circle' ? 'community_active' : ''}`}
                onClick={() => setActiveTab('circle')}
                >
                <p>サークル</p>
              </li>
              {hasDepartments && (
                <li
                  className={`text-center top__tabbar cursor-pointer px-2 ${activeTab === 'department' ? 'community_active' : ''}`}
                  onClick={() => setActiveTab('department')}
                >
                  <p>部署</p>
                </li>
              )}
              <li
                className={`text-center top__tabbar cursor-pointer px-2 ${activeTab === 'active' ? 'community_active' : ''}`}
                onClick={() => setActiveTab('active')}
                >
                <p>参加中</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container col-lg-8 bg-white pt-2 d-block d-md-none">
        <div className="row">
          {activeTab === 'all' && (
            <UserfeedColumn
              column="all"
              currentUser={currentUser}
              companyId={companyId}
              hashedCompanyId={hashedCompanyId}
              hasDepartments={hasDepartments}
            />
          )}
          {activeTab === 'circle' && (
            <UserfeedColumn
              column="circle"
              currentUser={currentUser}
              companyId={companyId}
              hashedCompanyId={hashedCompanyId}
              hasDepartments={hasDepartments}
            />
          )}  
          {activeTab === 'department' && (
            <UserfeedColumn
              column="department"
              currentUser={currentUser}
              companyId={companyId}
              hashedCompanyId={hashedCompanyId}
              hasDepartments={hasDepartments}
            />
          )}
          {activeTab === 'active' && (
            <UserfeedColumn
              column="active"
              currentUser={currentUser}
              companyId={companyId}
              hashedCompanyId={hashedCompanyId}
              hasDepartments={hasDepartments}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};


export default CommunityUserfeedList;
